// Google AdSense Auto Ads handles placement automatically via the script in index.html.
// This component renders a subtle inline placeholder that Auto Ads can target,
// while remaining visually clean if AdSense hasn't approved/loaded yet.
const AdSlot = ({ slotId, format = 'horizontal', className = '' }) => {
  const dims = format === 'vertical'
    ? 'h-[250px] sm:h-[600px]'
    : 'h-[90px] sm:h-[120px]';

  return (
    <div
      className={`w-full bg-gray-50 border border-gray-100 rounded-lg overflow-hidden flex items-center justify-center ${dims} ${className}`}
      data-ad-slot={slotId}
      data-testid={`ad-slot-${slotId}`}
    >
      <p className="text-xs text-gray-400 uppercase tracking-wider">Advertisement</p>
    </div>
  );
};

export default AdSlot;
